import { ElementNode } from 'lexical'
import type { DOMConversionMap, DOMConversionOutput, DOMExportOutput, EditorConfig, LexicalNode, SerializedElementNode } from 'lexical'

export function convertCollapsibleContentElement(_: HTMLElement): DOMConversionOutput {
  const node = $createCollapsibleContentNode()
  return {
    node
  }
}

export class CollapsibleContentNode extends ElementNode {
  static getType(): string {
    return 'collapsible-content'
  }

  static clone(node: CollapsibleContentNode): CollapsibleContentNode {
    return new CollapsibleContentNode(node.__key)
  }

  createDOM(_config: EditorConfig): HTMLElement {
    const dom = document.createElement('div')
    dom.classList.add('Collapsible__content')
    return dom
  }

  updateDOM(_prevNode: CollapsibleContentNode, _dom: HTMLElement): boolean {
    return false
  }

  static importDOM(): DOMConversionMap | null {
    return {
      div: (domNode: HTMLElement) => {
        if (!domNode.hasAttribute('data-lexical-collapsible-content')) {
          return null
        }
        return {
          conversion: convertCollapsibleContentElement as any,
          priority: 2
        }
      }
    }
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement('div')
    element.classList.add('Collapsible__content')
    element.setAttribute('data-lexical-collapsible-content', 'true')
    return { element }
  }

  static importJSON(_serializedNode: SerializedElementNode): CollapsibleContentNode {
    return $createCollapsibleContentNode()
  }

  isShadowRoot(): boolean {
    return true
  }

  exportJSON(): SerializedElementNode {
    return {
      ...super.exportJSON(),
      type: 'collapsible-content',
      version: 1
    }
  }
}

export function $createCollapsibleContentNode(): CollapsibleContentNode {
  return new CollapsibleContentNode()
}

export function $isCollapsibleContentNode(node: LexicalNode | null | undefined): node is CollapsibleContentNode {
  return node instanceof CollapsibleContentNode
}
